import { Flex, type FlexProps } from '@chakra-ui/react'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

export default function ProfileItemContainer({
  children,
  ...props
}: {
  children: React.ReactNode
} & FlexProps): JSX.Element {
  return (
    <Flex
      bgColor="bg"
      border={`2px solid ${chakraTokenToVar('border')}`}
      borderRadius={5}
      direction="column"
      height="100%"
      p={5}
      {...props}
    >
      {children}
    </Flex>
  )
}
